import { literal, type, string, boolean, number, is } from 'superstruct';

export const FORM_KIT_PERFORMANCE_GROUP = 'form-kit';

export const FORM_KIT_PERFORMANCE_SUBMIT_TRACK_GROUP = `${FORM_KIT_PERFORMANCE_GROUP}:submit`;
export const FORM_KIT_PERFORMANCE_VALIDATION_TRACK_GROUP = `${FORM_KIT_PERFORMANCE_GROUP}:validation`;

export const FORM_SUBMIT_MEASURE_NAME = `${FORM_KIT_PERFORMANCE_GROUP}:submit`;
export const FORM_SUBMIT_START_MARK_NAME = `${FORM_SUBMIT_MEASURE_NAME}:start`;
export const FORM_SUBMIT_FINISH_MARK_NAME = `${FORM_SUBMIT_MEASURE_NAME}:finish`;

export const FORM_VALIDATION_MEASURE_NAME = `${FORM_KIT_PERFORMANCE_GROUP}:form-validation`;
export const FORM_VALIDATION_START_MARK_NAME = `${FORM_VALIDATION_MEASURE_NAME}:start`;
export const FORM_VALIDATION_FINISH_MARK_NAME = `${FORM_VALIDATION_MEASURE_NAME}:finish`;

export const FIELD_VALIDATION_MEASURE_NAME = `${FORM_KIT_PERFORMANCE_GROUP}:field-validation`;
export const FIELD_VALIDATION_START_MARK_NAME = `${FIELD_VALIDATION_MEASURE_NAME}:start`;
export const FIELD_VALIDATION_FINISH_MARK_NAME = `${FIELD_VALIDATION_MEASURE_NAME}:finish`;

const formSubmitStruct = type({
    name: literal(FORM_SUBMIT_MEASURE_NAME),
    detail: type({
        formId: string(),
        formName: string(),
        isSubmitSuccessful: boolean(),
    }),
    entryType: literal('measure'),
    duration: number(),
});

const formValidationStruct = type({
    name: literal(FORM_VALIDATION_MEASURE_NAME),
    detail: type({
        formId: string(),
        formName: string(),
        cause: string(),
        isAsync: boolean(),
    }),
    entryType: literal('measure'),
    duration: number(),
});

const fieldValidationStruct = type({
    name: literal(FIELD_VALIDATION_MEASURE_NAME),
    detail: type({
        formId: string(),
        formName: string(),
        fieldId: string(),
        cause: string(),
        isAsync: boolean(),
    }),
    entryType: literal('measure'),
    duration: number(),
});

export function isFormSubmitPerformanceMeasure(entry: PerformanceEntry) {
    return is(entry, formSubmitStruct);
}

export function isFormValidationPerformanceMeasure(entry: PerformanceEntry) {
    return is(entry, formValidationStruct);
}

export function isFieldValidationPerformanceMeasure(entry: PerformanceEntry) {
    return is(entry, fieldValidationStruct);
}
